export interface NavItemConfig {
  id: string;
  href: string;
  onClick: () => void;
  className?: string;
  icon: string;
  iconAlt: string;
  label: string;
  badge?: {
    count: number;
    className: string;
  };
  isVisible: boolean;
}

export enum ActiveTabKey {
  Timeline = 'timeline',
  InsightsAndActions = 'insightsAndActions',
  Predictions = 'predictions',
  SharedWellbeingPlan = 'sharedWellbeingPlan',
  InsightSettings = 'insightSettings',
  InvitePatient = 'invitePatient',
  OsaNavigatorApp = 'osaNavigatorApp',
  InterventionSettings = 'interventionSettings',
}
export interface NavbarLeftProps {
  activeItem: ActiveTabKey;
  sendToParent: (selection: ActiveTabKey) => void;
  activeInsightsCnt?: number;
  actionsCnt?: number;
}

export interface UserContextType {
  userState: {
    unsavedData: boolean;
  };
  setUserState: (state: { unsavedData: boolean }) => void;
}
